import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { Map, List, Iterable } from 'immutable';
import { ButtonWithIcon } from '@els/els-react--button';

function StructureData({ breadcrumb, openBatchExecutionDetails, showStructurePopup }) {
  const openBatchDetails = () => {
    openBatchExecutionDetails(breadcrumb.toJS());
  };

  const getQuickSearchStructure = () => breadcrumb.getIn(['quickSearchItem', 'structure']);

  const getQueryBuilderStructures = () => {
    const structures = breadcrumb.get('structures');
    return Iterable.isIterable(structures) ? structures : List();
  };

  const quickSearchStructure = getQuickSearchStructure();
  const queryBuilderStructures = getQueryBuilderStructures();

  return (
    <>
      <span className="crumb-comment">
        {breadcrumb.get('batchSearch') && (
          <ButtonWithIcon
            data-e2e="execution-details-btn"
            type="link"
            sprite="ChevronRight"
            iconRight
            onClick={openBatchDetails}
            className="pull-right breadcrumb-open-batch__button e2e-breadcrumb-open-batch">
            Execution details
          </ButtonWithIcon>
        )}
        <InnerHTML tag="span" html={breadcrumb.get('batchComment') || breadcrumb.get('comment')} className="e2e-breadcrumb-comment" />
      </span>

      {quickSearchStructure && (
        <ButtonWithIcon
          data-e2e="quick-search-structure-btn"
          type="tertiary"
          size="small"
          sprite="Structure"
          iconOnly
          className="u-els-display-inline-block u-els-margin-left-1o2 e2e-breadcrumb-structure"
          onClick={() => {
            showStructurePopup(quickSearchStructure);
          }}
          aria-label="Show quick search structure">
          Structure
        </ButtonWithIcon>
      )}

      {queryBuilderStructures.map((structureData, index) => (
        <ButtonWithIcon
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          data-e2e="query-builder-structure-btn"
          type="tertiary"
          size="small"
          sprite="Structure"
          iconOnly
          className="u-els-display-inline-block u-els-margin-left-1o2 e2e-breadcrumb-structure"
          onClick={() => {
            showStructurePopup(structureData.get('structure'));
          }}
          aria-label="Show query builder structure">
          Structure
        </ButtonWithIcon>
      ))}
    </>
  );
}

StructureData.propTypes = {
  breadcrumb: PropTypes.instanceOf(Map).isRequired,
  openBatchExecutionDetails: PropTypes.func.isRequired,
  showStructurePopup: PropTypes.func.isRequired,
};

export default StructureData;
